import { Component, Input } from '@angular/core';
import { OverviewActivityItem } from '../../models/overview.model';
import { LedgerRow } from '../../../billing/components/txn-table/txn-table';

@Component({
  selector: 'app-recent-activity-card',
  standalone: false,
  templateUrl: './recent-activity-card.html',
})
export class RecentActivityCard {
  @Input({ required: true }) items: OverviewActivityItem[] = [];

  /** View-only: the overview's activity items in the shared ledger table's row shape. */
  get rows(): LedgerRow[] {
    return this.items.map(item => ({
      id: item.id,
      createdAt: item.occurredAt,
      kind: item.kind,
      description: item.description,
      // `amount` is the unsigned decimal string the API returns ("25.00").
      amountCents: Math.round(parseFloat(item.amount) * 100),
      currency: item.currency,
      isCredit: item.isCredit,
      status: item.status,
    }));
  }
}
